
import React, { Component}  from 'react';

import { DetailProvider, DetailContext } from 'core/DetailProvider';
import { FormContext, FormProvider } from 'core/FormProvider';
import { YellowButton } from 'ui/Button';
import { ChoiceForm } from './Form';
import Layout from 'components/Dashboard/Layout';


export default class ChoiceDetail extends Component {

  onLoaded = (item) => {
    document.title = `Значение ${item.name}`;
  };

  postSave = () => {
    const { history } = this.props;
    history.push('/catalog/choice');
  }

  render() {
    const { match } = this.props;
    return (
      <DetailProvider
        url={`catalog/choice/${match.params.id}`}
        onLoaded={(item) => this.onLoaded(item)}
      >
        <DetailContext.Consumer>
          {detailContext => {
            let { item } = detailContext;
            return (
              <FormProvider
                url={item.meta.url}
                postSaveMessage={'Значение обновлено'}
                postSave={(item) => this.postSave()}
                item={item}
              >
                <FormContext.Consumer>
                {formContext => {
                  const { loading } = formContext;
                  return (
                    <Layout>
                      <Layout.Header
                        title={'Редактирование значения'}
                        backUrl={'/catalog/choice'}
                      />

                      <Layout.ContentSimple>
                        <ChoiceForm />

                        <div className={'mt-30'}>
                          <YellowButton
                            onClick={(e) => formContext.handleSubmit(e)}
                            disabled={loading}
                            size={'large'}
                          >
                            Обновить
                          </YellowButton>
                        </div>
                      </Layout.ContentSimple>

                    </Layout>
                  )
                }}
                </FormContext.Consumer>
              </FormProvider>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
